import { SaveButton } from "components/Buttons"
import { URL_PATHS } from "constants/index"
import React from "react"
import { Link } from "react-router-dom"
import { Col, Container, Row } from "reactstrap"

const CancelledBookingScreen = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div style={{ textAlign: "center" }}>
            <Row className="my-3">
              <h3>BOOKING WAS NOT CREATED</h3>
            </Row>
            <Row className="my-3">
              <span>
                It seems that you have cancelled your payment.{<br />}
                The booking will not be created. {<br />}
                If you want to create the booking, you will have to create a new
                one and finalize the payment.
              </span>
            </Row>
            <Row className="d-flex justify-content-center mt-5">
              <Col xs="auto">
                <Link to={URL_PATHS.BOOKING_CALENDAR} className="dropdown-item">
                  <SaveButton type="button" content="Go to Bookings Screen" />
                </Link>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default CancelledBookingScreen
